import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useSite } from "@/context/SiteContentContext";
import { Reveal, SectionTag } from "./Reveal";

export default function WhyUs() {
  const { t, lang } = useLang();
  const { settings } = useSite();
  const items = t.why.items.map((it, i) => settings[`why_${i}_${lang}`] || it);
  return (
    <section id="why" className="relative section-pad" data-testid="why-section">
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 20% 50%, rgba(10,30,78,0.4), transparent 55%)" }} />
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <Reveal><SectionTag>{t.why.tag}</SectionTag></Reveal>
          <Reveal delay={0.05}>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mt-5">{t.why.title}</h2>
          </Reveal>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((item, i) => (
            <Reveal key={i} delay={(i % 4) * 0.07}>
              <motion.div whileHover={{ y: -6 }} className="card-surface rounded-2xl p-6 h-full flex flex-col gap-4" data-testid={`why-card-${i}`}>
                <CheckCircle2 size={26} className="text-primary" />
                <span className="font-bold text-base sm:text-lg">{item}</span>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
